// extracted by mini-css-extract-plugin
module.exports = {"rightIcon":"Button__rightIcon--37E9X","button":"Button__button--3_Ozh"};